import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({ endPoint: 'OperationType/All', method: 'GET', body: null, token: token })
}
